import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { ComplianceDueDate } from "./ComplianceBits";
import { HANDBOOK_REQUIRED_PATH } from "./HseReadReminder";

const PREVIEW = 3;

/**
 * Front page «Personalhåndbok»: the reader's required HMS documents with deadlines
 * (PROMANG_COMPONENTS.md §8.2/§8.5). `reading` is `GET /hse/document_compliance/me`.
 */
export function HomeReadingCard({ reading, onOpen }) {
  const { t } = useTranslation();
  if (!reading?.enabled) return null;

  if (!reading.count) {
    return (
      <div className="pm-alert pm-alert--ok" role="status">
        <span className="pm-alert__icon" aria-hidden="true">✓</span>
        <div className="pm-alert__title">{t("hseCompliance.home.none")}</div>
      </div>
    );
  }

  const overdue = reading.overdue_count > 0;
  const items = (reading.items || []).slice(0, PREVIEW);
  return (
    <div className={`pm-alert ${overdue ? "pm-alert--bad" : "pm-alert--warn"} flex-col !gap-2`} role="status">
      <div className="flex w-full items-start gap-3">
        <span className="pm-alert__icon" aria-hidden="true">!</span>
        <div className="min-w-0 flex-1">
          <div className="pm-alert__title">{t("hseCompliance.home.required", { count: reading.count })}</div>
          {overdue ? (
            <div className="pm-alert__desc">{t("hseCompliance.home.overdue", { count: reading.overdue_count })}</div>
          ) : null}
        </div>
      </div>
      <ul className="w-full divide-y divide-[color:var(--pls-border)] overflow-hidden rounded-[10px] border border-[color:var(--pls-border)] bg-[color:var(--pls-surface)]">
        {items.map((item) => (
          <li key={item.requirement_id}>
            <button
              type="button"
              className="flex min-h-[44px] w-full items-center gap-2 px-3 py-2 text-left hover:bg-[color:var(--pls-surface2)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1463C7]"
              onClick={() => onOpen(item.url)}
            >
              <span className="min-w-0 flex-1 truncate text-[13px] font-medium text-[color:var(--pls-fg)]">{item.title}</span>
              <span className="shrink-0 text-[12px]">
                <ComplianceDueDate dueAt={item.due_at} overdue={item.overdue} />
              </span>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-[color:var(--pls-faint)]" aria-hidden="true" />
            </button>
          </li>
        ))}
      </ul>
      {reading.count > PREVIEW ? (
        <button type="button" className="pm-btn pm-btn--ghost pm-btn--sm self-start" onClick={() => onOpen(HANDBOOK_REQUIRED_PATH)}>
          {t("hseCompliance.home.show_all", { count: reading.count })}
        </button>
      ) : null}
    </div>
  );
}

export default HomeReadingCard;
